import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { bookingStatus } from '../../api/bookingAPI';
import './paymentPending.css';

export default function PaymentPending() {
    const [loading, setLoading] = useState(true);

    // Get bookingId from URL or session
    const params = new URLSearchParams(window.location.search);
    const bookingId = params.get('bookingId') || sessionStorage.getItem('bookingId');

    useEffect(() => {
        if (!bookingId) {
            window.location.href = '/review-booking';
            return;
        }

        setLoading(true);

        const checkInterval = 3000; // Poll every 3 seconds
        const timeoutLimit = 180000; // 3 minutes

        // Start polling backend for payment status
        let intervalId = setInterval(async () => {
            try {
                const res = await bookingStatus('act', bookingId);
                if (res?.data?.status === 'Paid') {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);

                    // Payment successful
                    window.location.href = '/booking-confirmation';
                }
            } catch (err) {
                console.error('Payment status check failed:', err);
            }
        }, checkInterval);

        // Timeout after 3 minutes
        const timeoutId = setTimeout(() => {
            clearInterval(intervalId);
            window.location.href = '/review-booking';
        }, timeoutLimit);

        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
    }, [bookingId]);

    return (
        <div className='loadingBackgroundPayment'>
            <ReactLoading type='spin' color='#006aff' className='loadingSpinPayment' />
            <p className='loadingText'>Please wait while we verify your payment…</p>
        </div>
    );
}
